"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _types = require('../useInbox/types');









const LABELS = {
  [_types.InboxTab.ALL]: 'All',
  [_types.InboxTab.UNREAD]: 'Unread',
  [_types.InboxTab.REQUESTS]: 'Requests',
  [_types.InboxTab.PATIENTS]: 'Patients',
  [_types.InboxTab.TEAM]: 'Staff',
  [_types.InboxTab.SCHEDULED]: 'Scheduled',
}

const pill = (tab, count) => ({ tab, label: LABELS[tab], count })

/* The Requests pill: its count is the chats with an open request (from the
 * open requests, never GetInboxCounts). Shown while above 0, or while it is
 * the selected pill, so emptying it doesn't move you. */





const NO_REQUESTS = { count: 0, isSelected: false }

/* The pills for the list on screen, WhatsApp-style. Unread, Patients and
 * Staff show their unread chats, Requests and Scheduled their chats, All no
 * number. Requests follows Unread (see RequestsPillState). Patients
 * shows only when you can see patient chats and the list has some; Scheduled
 * always shows. Until the counts arrive (or if they fail, or a list's alone
 * does) the pills show without numbers. */
 const inboxPills = (
  counts,
  canSeePatients,
  requests = NO_REQUESTS,
) => {
  const requestsPill = requests.count > 0 || requests.isSelected ? [pill(_types.InboxTab.REQUESTS, requests.count)] : []
  if (!counts) {
    return [
      pill(_types.InboxTab.ALL),
      pill(_types.InboxTab.UNREAD),
      ...requestsPill,
      ...canSeePatients ? [pill(_types.InboxTab.PATIENTS)] : [],
      pill(_types.InboxTab.TEAM),
      pill(_types.InboxTab.SCHEDULED),
    ]
  }
  const { ALL: all, PATIENTS: patients, TEAM: staff, SCHEDULED: scheduled } = counts
  return [
    pill(_types.InboxTab.ALL),
    pill(_types.InboxTab.UNREAD, _optionalChain([all, 'optionalAccess', _ => _.UnreadChats])),
    ...requestsPill,
    ...canSeePatients && patients && patients.Total > 0 ? [pill(_types.InboxTab.PATIENTS, patients.UnreadChats)] : [],
    pill(_types.InboxTab.TEAM, _optionalChain([staff, 'optionalAccess', _2 => _2.UnreadChats])),
    pill(_types.InboxTab.SCHEDULED, _optionalChain([scheduled, 'optionalAccess', _3 => _3.Total])),
  ]
}; exports.inboxPills = inboxPills

// "51", "999+".
 const formatPillCount = (n) => n > 999 ? '999+' : String(n); exports.formatPillCount = formatPillCount
